import { render, staticRenderFns } from "./addReference.vue?vue&type=template&id=33f08458&scoped=true"
import script from "./addReference.vue?vue&type=script&lang=js"
export * from "./addReference.vue?vue&type=script&lang=js"
import style0 from "./addReference.vue?vue&type=style&index=0&id=33f08458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f08458",
  null
  
)

export default component.exports